import * as React from 'react';
export var Columns = function Columns(_ref) {
  var children = _ref.children,
      verticalCenter = _ref.verticalCenter,
      align = _ref.align,
      colSizes = _ref.colSizes;
  return /*#__PURE__*/React.createElement("div", {
    className: "columns is-multiline " + (verticalCenter && 'is-vcentered'),
    style: {
      textAlign: align ? align : 'left'
    }
  }, React.Children.map(children, function (child, idx) {
    return /*#__PURE__*/React.createElement("div", {
      className: "column " + (colSizes && colSizes[idx] ? colSizes[idx] : '')
    }, child);
  }));
};